import React, {Component} from 'react';
import { connect } from 'react-redux';
import { components } from 'react-select/dist/react-select.cjs.prod';
import { bindActionCreators } from 'redux';
import HeaderComponent from '../HeaderComponent';
import {fetchIVRMapping} from '../../actions/fetchAllMapping';
import {fetchCurrentCalls,fetchResponsiblePersonMapping} from '../../actions/IVRActions';
import Select from "react-select";
import { CSVLink } from "react-csv";
import ReactTable from 'react-table';
import '../../styles/returnOrder.css'
import {currentCallsColumn} from '../../config/column_fields'
import { Link } from 'react-router-dom';




class IVRCurrentCallView extends Component {
    constructor(props){
        super();
        this.state = {
            allTickets : [],
            filters: {
               
            },
            showFilter: false,
            ticketMapping: {},
            page: 0,
            limit: 500,
            ticketsDataReceived: false,
            userObj: {},
            responsibleMapping:{},
            currentCallsData:[],
            currentCallsCounts:{},
            callTypeMapping:[{label:"incoming",value:"incoming"},{label:"outbound",value:"outbound"}],
            callStatusMapping:[{label:"completed",value:"completed"},{label:"missed",value:"missed"},{label:"not connected",value:"not connected"},{label:"out of office",value:"outofoffice"}],
            optionSelectedMapping:[{label:"1 Order Status",value:"1"},{label:"2 Configuration",value:"2"},{label:"3 Payment Issue",value:"3"},{label:"4 RO",value:"4"},{label:"5 Other Query",value:"5"}]


        }
    }

    componentDidMount(){
        this.props.fetchIVRMapping();
        this.props.fetchResponsiblePersonMapping();
        if(localStorage.getItem("userObj")){
          let userObj = JSON.parse(localStorage.getItem("userObj"));
          this.setState({
            userObj
          })
        }
    
      }
    


    componentWillMount() {
        this.props.fetchCurrentCalls();
        // setInterval(this.props.fetchCurrentCalls(), 1000);
    }

    componentWillReceiveProps(props) {
        let { allTickets, ticketsDataReceived = false, ticketMapping,responsibleMapping,currentCallsData,currentCallsCounts={} } = props
        console.log('ticketMapping',ticketMapping);
        console.log('ticketsDataReceived',ticketsDataReceived);
        // currentCallsCounts.optionSelectedCount = {"Order Status":0,"Configuration":0,"Payment Issue":0,"RO":0,"Other Query":0,"Callback":0}
        this.setState({
            allTickets: allTickets,
            ticketsDataReceived,
            ticketMapping,
            responsibleMapping,
            currentCallsData,
            currentCallsCounts
            })
    }
    handleFilterToggle = () => {
        let val = !this.state.showFilter;
        this.setState({
            showFilter: val,

        })
    }

    handleInputDateChangeFilters = (e, type) => {
        let { filters } = this.state;
        let { name, value } = e.target;
        filters = JSON.parse(JSON.stringify(filters));
        filters[name] = value;
        this.setState({
            filters
        })
    }
    handleSelectChangeFilters = (e, name) => {
        // let value = (e || []).map(option => option.value);
        let value = e.value 
        let {filters} = this.state
        

        this.setState({
            filters: {
                ...filters,
                [name]: value
            }
        })

    }

    fetchMoreTickets = () => {
        let { page, limit, allTickets, filters } = this.state;
        // this.props.fetchAllTickets(page + 1,limit,allTickets,filters);
        this.setState({
            page: page + 1,
            ticketsDataReceived: false
        })
    }


    onApplyFilter = () => {
        let { limit, filters } = this.state;
        console.log('filters', filters);
        let filtersValue = {}
        for(let key in filters){
            if(filters[key]){
                filtersValue[key] = filters[key]
            }

        }
        if(Object.keys(filtersValue).length){
        this.props.fetchCurrentCalls(filtersValue);
        }
    }

    // handleEditReturnOrderDataClick = (row)=>{
    //     let{uniqueRowId} = row;
    //     this.setState({
    //         returnOrderEditFlag:{
    //             ...this.state.returnOrderEditFlag,
    //             [uniqueRowId]:true
    //         },
    //         editedReturnOrderData:{
    //             ...this.state.editedReturnOrderData,
    //             [uniqueRowId]:row
    //         }
    //     })
    // }

    // handleCancelReturnOrderDataClick = (row)=>{
    //     let {uniqueRowId} = row.original;
    //     this.setState({
    //         returnOrderEditFlag:{
    //             ...this.state.returnOrderEditFlag,
    //             [uniqueRowId]: false
    //         },
    //         editedReturnOrderData:{
    //             ...this.state.editedReturnOrderData,
    //             [uniqueRowId]:false
    //         }
    //     })


    // }

    // handleSaveReturnOrderDataClick = (row) => {
    //     let {uniqueRowId} = row.original;
    //     let KeysCanBeChanged = ["qcChecked", "qcStatus", 'sent', "damageClaimAmount","damageClaimDate","damageClaimId","itemReceived","putaway","qcFeedback"]
    //     let {editedReturnOrderData,returnOrders, userObj} = this.state
    //     let newData = editedReturnOrderData[uniqueRowId];
    //     let newDataToSend = {};
    //     let updatedBy = userObj.email;
    //     KeysCanBeChanged.map((key)=>{
    //         if(newData[key]!= row.original[key]){
    //             newDataToSend[key] = newData[key];
    //         }
    //     })
        
    //     newDataToSend.updatedBy = updatedBy;
    //     if(!Object.keys(newDataToSend).length){
    //         return;
    //     }
    //     this.props.updateRetunOrderData(uniqueRowId,newDataToSend, returnOrders)
    //     this.setState({
    //         returnOrderEditFlag:{
    //             ...this.state.returnOrderEditFlag,
    //             [uniqueRowId]: false
    //         },
    //         editedReturnOrderData:{
    //             ...this.state.editedReturnOrderData,
    //             [uniqueRowId]:false
    //         }
    //     })

    // }
    
    multiSelectType = (name, options, placeholder) => {
        return (
            <div className="form-group" style={{ width: '100%' }}>
                <Select
                    isSearchable
                    onChange={(e) => { this.handleSelectChangeFilters(e, name) }}
                    placeholder={placeholder}
                    name={name}
                    options={options}
                />
            </div>
        )
    }
    inputType = (name, placeholder, type) => {
        return (
            <div className="form-group">
                <div className="input-group mb-3">
                   {type=="date" &&  <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">{placeholder}</span>
                    </div>}
                    <input className="form-control customInput" type={type} name={name} placeholder={placeholder} onChange={(e) => this.handleInputDateChangeFilters(e)} />
                </div>
            </div>
        )
    }

    // handleOrderChanges = (e,row)=>{
    //     let {name, value} = e.target;
    //     let {uniqueRowId} = row.original
    //     let {editedReturnOrderData} = this.state;
    //     editedReturnOrderData = JSON.parse(JSON.stringify(editedReturnOrderData));
    //     editedReturnOrderData[uniqueRowId][name] = value;
    //     this.setState({
    //         editedReturnOrderData
    //     })


    // }
    // InputTypeText = (name, value, type, row ) => {
    //     return (
    //         <input type={type} name ={name} value = {value} className="form-control"  onChange={(e) => this.handleReturnOrderChanges(e, row)} ></input>
    //     )
    // }
    // renderInputCell = (row) => {
    //     let { id, type } = row.column;
    //     let {returnOrderEditFlag} = this.state
    //     let checked = ["damaged/missing product","wrong product"]
    //     return (
    //             returnOrderEditFlag[row.original.uniqueRowId]  && checked.includes(row.original.qcStatus)? this.InputTypeText( id,  this.state.editedReturnOrderData[id] , type, row): row.value
    //     )
    // }

    // ticketSelect = (name, options,  placeholder, row, value='' ) => {
    //     // console.log('options', options);
    //     return (
    //         <div style={{ width: '100%' }}>
    //     <select
    //       onChange={(e) => { this.handleReturnOrderChanges(e,row) }}
    //       className="form-control" id="sel1" name={name} value={value}
    //     >
    //       <option>{placeholder}</option>
    //       {(options ? options : []).map(e => <option key={e.value}>{e.label}</option>)}
    //     </select>
    //   </div>
    //     )
    // }


    render(){ 
        let {ticketMapping,ticketsDataReceived, allTickets, showFilter,responsibleMapping, handleSelectChangeFilters ,filters,currentCallsData, currentCallsCounts, callStatusMapping, callTypeMapping,optionSelectedMapping} = this.state
        let { handleFilterToggle, inputType, onApplyFilter, fetchMoreTickets } = this


        return (
            <div>
                <HeaderComponent/>
                <div className="container-fluid">
                <div style={{ "marginTop": 60 }} className="topbar-section allLeadViewFilters">
                    <div className="col-md-4"><b>Filters | {this.state.showFilter ? <i onClick={handleFilterToggle} style={{ cursor: "pointer" }} class="fa fa-eye-slash"></i> : <i onClick={handleFilterToggle} style={{ cursor: "pointer" }} class="fa fa-eye"></i>} </b></div>
                    <hr className={showFilter ? "showFilter" : "hideFilter"}></hr>
                    <div className={`${showFilter ? "showFilter" : "hideFilter"} ${"row"}`}>
                        <div className="col-md-3">
                            {inputType("startDate", "Start  Date", "date")}
                        </div>
                        <div className="col-md-3">
                            {inputType("endDate", "End  Date", "date")}
                        </div>
                        <div className="col-md-3">
                                {this.multiSelectType("callType", callTypeMapping, "Call Type")}
                        </div>
                        <div className="col-md-3">
                                {this.multiSelectType("status", callStatusMapping, "Call Status")}
                        </div>
                        <div className="col-md-3">
                                {this.multiSelectType("optionSelected",  optionSelectedMapping, "Option Selected")}
                        </div>
                        
                        <div className="col-md-3">
                            {inputType("customerPhoneNumber", "phone number", "number")}
                        </div>
                       
                        

                        
                        <div className="col-md-3">
                            <button onClick={onApplyFilter} className="btn btn-success">Apply filter</button>
                        </div>
                    </div>


                </div>
                <div className="callContainer">
                    <div className='callCountContainer'>
                      <p>Total incoming call  today</p>
                      <h5>{currentCallsCounts.totalIncomingCallsToday || 0}</h5>

                    </div>
                    <div className='callCountContainer'>
                      <p>Total answered call  today</p>
                      <h5>{currentCallsCounts.totalAnsweredCallsToday || 0}</h5>

                    </div>
                    <div className='calDistributionContainer'>
                        <h5 className='callHeadText'>call type distribution</h5>
                        {Object.keys(currentCallsCounts.optionSelectedCount || {}).map((option)=>(
                            <div className='callCountContainer'>
                            <p>{option.toLowerCase()}</p>
                            <h5>{currentCallsCounts.optionSelectedCount[option]}</h5>
      
                          </div>
                        ))}

                    </div>
                    
                    <div style={{ float: "right" }}>
                    </div>

                </div>


                <ReactTable
                    filterable={true}
                    showPagination={true}
                    sortable={true}
                    data={currentCallsData}
                    columns={currentCallsColumn}
                    defaultSorted={[{ id: "createdOn", desc: false }]}
                    style={{ height: "90vh", textAlign: 'center' }}
                    defaultFilterMethod={(filter, row) => String(row[filter.id]).toLowerCase().indexOf(filter.value.toLowerCase()) > -1}
                />

            </div>

            </div>
        )
    }
}

function mapStateToProps(state) {
    let ticketMapping = state.fetchAllMapping && state.fetchAllMapping.IVRMapping || {}
    console.log('ticketMapping2',ticketMapping);
    let {allTickets, ticketsDataReceived,responsibleMapping,currentCallsData,currentCallsCounts} = state.IVRReducer
    // let 
    return {
        ticketMapping,
        allTickets,
        ticketsDataReceived,
        responsibleMapping,
        currentCallsData,
        currentCallsCounts
    }

   
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ fetchCurrentCalls, fetchIVRMapping,fetchResponsiblePersonMapping }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(IVRCurrentCallView);
